import type { ReactNode } from 'react'
import React from 'react'
import { AccordionItem } from './AccordionItem'

export type Props = {
  children: ReactNode
}

export const Accordion = ({ children }: Props) => {
  return <div data-testid="Accordion">{children}</div>
}

Accordion.Item = AccordionItem
